import React,{useState, useEffect} from 'react'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import add_contract_dialog from '../assets/add_contract_dialog.svg'
import add_forecast_dialog from '../assets/add_forecast_dialog.svg'
import close_dialog from '../assets/close_dialog.svg'
import Draggable from 'react-draggable';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function PopupDelete({refresh, setRefresh, setOpenPopup, id, contract, mainID, name, openPopup, setLoading, taskID}) {
    const handleDelete = () => {
        if(contract){
            fetch('/api-dev/expenses/DeleteMainBudgetLine/'+(id),{
                method: "DELETE",
                
                }).then((e)=>console.log("deleted in database"))
        }else{
            fetch('/api-dev/expenses/DeleteBudgetLine/'+id,{
                method: "DELETE",
                 
                }).then((e)=>console.log("deleted in database"))
                
             }
             setOpenPopup(false)
             setRefresh(prev => !prev)
             setLoading(true)
                  
        }
    
  return (
    <Dialog 
    open={openPopup} 
    maxWidth="550px" 
    style={{borderRadius:'10px'}}
    PaperComponent={PaperComponent}
    aria-labelledby="draggable-dialog-title"
     >
    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title" >
    <div style={{ display: 'flex' }}>
            <Typography variant="h6" component="div" style={{ flexGrow: 15 }}>
                <div>
                   {contract ? <>
                   <img src={add_contract_dialog} alt="add-contract-dialog" className='add-contract-dialog-icon'/>
                   <span className='add-contract-dialog-title'>
                    Delete contract
                   </span>
                   </> : <>
                   <img src={add_forecast_dialog} alt="add-contract-dialog" className='add-contract-dialog-icon'/>
                   <span className='add-contract-dialog-title'>
                    Delete forecast
                   </span>
                   </>} 
                </div>
             
            </Typography>
          <div style={{flexGrow: 1, textAlign:'right'}} >
          
          <IconButton  onClick={()=>setOpenPopup(false)}>
            <img src={close_dialog} alt="close-dialog" className='close-dialog-icon'/>
          </IconButton>
          </div>
        </div>
    </DialogTitle>
    <DialogContent >
        {/*<div style={{width:'500px',height:'300px',marginTop:'50px'}}>
       name : {name} <br/>
       value : {value}    <br/>
       id : {id} <br/>
       main id : {mainId}
                   </div>*/}
        <div style={{width:'500px',marginTop:'30px'}}>
        <button onClick={()=>handleDelete()} style={{cursor:'pointer'}} type="submit" className='form-submit'>
                &nbsp;
                <span className='form-submit-text'>Delete {contract ? 'contract' : 'forecast'}</span>
            </button>
        </div>
    </DialogContent>
</Dialog>
  )
}

export default PopupDelete